module.exports = __webpack_public_path__ + "media/video.962c1a94.mp4";